import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M7 13c4 0 6 3 6 3l-1 3H2l-1-3s2-3 6-3"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 12C2.516 12 .26 15.305.168 15.445a1.003 1.003 0 0 0-.117.871l1 3A1 1 0 0 0 2 20h10c.43 0 .812-.275.948-.684l1-3a1 1 0 0 0-.116-.871C13.738 15.305 11.482 12 7 12zM7 2c1.654 0 3 1.346 3 3S8.654 8 7 8 4 6.654 4 5s1.346-3 3-3m0 8c2.757 0 5-2.243 5-5S9.757 0 7 0 2 2.243 2 5s2.243 5 5 5m4.279 8h-8.56l-.6-1.804C2.74 15.492 4.369 14 6.999 14c2.638 0 4.26 1.489 4.882 2.194L11.279 18zm7.72-9h-6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2"
});

var SvgCustomerMinusMajorTwotone = function SvgCustomerMinusMajorTwotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export { SvgCustomerMinusMajorTwotone as S };